export default __webpack_public_path__ + "6d074b948e8e6dbf953f1e72bc874677.svg";